import React from 'react';

type TProps = {
  isActive: boolean;
  color: string;
};

export const ColorIcon = ({ isActive, color }: TProps) => {
  const borderParams = isActive
    ? {
        x: '1',
        y: '1',
        width: '38',
        height: '38',
        rx: '19',
        fill: 'white',
        stroke: 'var(--background-accent)',
        strokeWidth: '2',
      }
    : {
        x: '0.5',
        y: '0.5',
        width: '39',
        height: '39',
        rx: '19.5',
        fill: 'white',
        stroke: 'var(--control-secondary)',
      };

  return (
    <svg
      data-qa="color-icon-pdp"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect {...borderParams} />
      <rect x="4" y="4" width="32" height="32" rx="16" fill={color} />
    </svg>
  );
};
